import { React, useState, useEffect } from 'react';
import './recruitmentDetail.scss';
import { GetOfferList } from '../../apis/base';
import IntroModule from '../../components/Intromodule/Intromodule.js';

function RecruitmentDetail(props) {
  const [offerDetail, updateOfferDetail] = useState({
    offerTitle: '',
    keywords: [],
    modules: [],
  });
  const [requestErr, updateRequestErr] = useState(false);
  // 获取招聘信息列表页面数据
  const getOfferDetail = (offerIndex) => {
    const params = {
      filter: `offerIndex=${parseFloat(offerIndex)}`,
    }
    GetOfferList(params).then((res) => {
      const offerInfo = res && res[0] ? res[0] : {};
      const modules = [];
      offerInfo.roles && modules.push({ ...JSON.parse(offerInfo.roles), moduleName: 'Roles & Responsibilities', moduleIdx: 'role' });
      offerInfo.qualifications && modules.push({ ...JSON.parse(offerInfo.qualifications), moduleName: 'Qualifications', moduleIdx: 'qualifications' });
      offerInfo.apply && modules.push({ ...JSON.parse(offerInfo.apply), moduleName: 'How to apply？', moduleIdx: 'apply' });
      offerInfo.aboutWeTV && modules.push({ ...JSON.parse(offerInfo.aboutWeTV), moduleName: 'About WeTV', moduleIdx: 'WeTV' });
      const keywords = [];
      offerInfo.workPlace && keywords.push(offerInfo.workPlace);
      if (offerInfo._ctime) {
        const pubDate = new Date(offerInfo._ctime);
        const pubDateStr = `${pubDate.getFullYear()}-${pubDate.getMonth() + 1}-${pubDate.getDate()}`;
        keywords.push(`Publish Date: ${pubDateStr}`);
      }
      offerInfo.expireDate && keywords.push(`Expire Date: ${offerInfo.expireDate}`);
      offerInfo.sarary && keywords.push(offerInfo.sarary);
      offerInfo.jobType && keywords.push(offerInfo.jobType);
      const offerTitle = offerInfo.offerTitle || '';
      res && res[0] && updateOfferDetail({
        ...offerDetail,
        offerTitle,
        keywords,
        modules,
      });
    }, (_err) => {
      updateRequestErr(true);
    });
  };

  useEffect(() => {
    let offerIndex = '';
    if (props && props.match && props.match.params && props.match.params.id) { offerIndex = props.match.params.id }
    getOfferDetail(offerIndex);
    // eslint-disable-next-line
  }, [props]);

  return (
    <div className="recruitmentDetail">
      <h2 className="recruitmentDetailTitle">
        WeTV CAREERS
      </h2>
      {!requestErr ? (
        <div>
          <div className="offerMainInfo">
            <h3 className="offerTitle">{offerDetail.offerTitle}</h3>
            <div className="offerKeyWords">
              {offerDetail.keywords.map((item, index) => (
                <div
                  className="offerKeyWord"
                  key={index}>
                  <span>
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
          {offerDetail.modules.map((item, index) => (
            <IntroModule
              key={index}
              moduleContent={item}
            >
            </IntroModule>
          ))}
        </div>
      ) : (
        <div className="requestErr">
          {requestErr ? 'Please refresh the page and try again' : ''}
        </div>)}
    </div>
  );
}

export default RecruitmentDetail;
